import { Button, Text } from '@chakra-ui/core';
import React, { ChangeEvent, memo, useCallback, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Input from 'src/components/Input';
import Toast from 'src/components/Toast';
import * as yup from 'yup';
import { Form, Formik, FormikProps, FormikHelpers } from 'formik';
import { Container, Content } from './styles';
import { AuthContext } from 'src/hooks/useAuth';

type Values = {
  email: string;
  registration: string;
};

const initValues: Values = {
  email: '',
  registration: ''
}

const validationSchema = yup.object().shape({
  email: yup.string().required('Obrigatório').email('E-mail inválido.'),
  registration: yup.string().required('Obrigatório')
});

const messages: any = {
  'invalid-registration': 'Credenciais inválidas.',
  'user-not-found': 'Usuário não encontrado.'
};

const Login = memo(() => {
  const history = useHistory();
  const toast = Toast();
  const { login } = useContext(AuthContext);

  const onSubmit = async (values: Values, formikHelpers: FormikHelpers<Values>) => {
    try {
      await login(values.email, values.registration);
      history.push('/relatorio-reserva');
    } catch (err) {
      var messageValue = '';
      if (err?.response?.data?.message)
        messageValue = messages[err?.response?.data?.message];

      toast.error(messageValue);
      formikHelpers.setSubmitting(false);
    }
  };

  const handleOnChange = useCallback((e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>, formik: FormikProps<Values>) => {
    const { name } = e.currentTarget;
    formik.setFieldTouched(name, true, false);
    formik.setFieldValue(name, e.currentTarget.value, true);
  }, []);

  return (
    <Container>
      <Content>
        <Formik
          initialValues={initValues}
          validateOnMount={false}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {(formik) =>
            <Form>
              <div>
                <Text zIndex={1} fontSize="4xl" color="#01509C" marginBottom="20px">
                  Login
                </Text>
                <Input
                  name='email'
                  label='Email'
                  onChange={(e: any) => handleOnChange(e, formik)} error={formik.errors}
                  isFullWidth />
                <Input
                  name='registration'
                  label='Senha'
                  type='password'
                  margin='none'
                  onChange={(e: any) => handleOnChange(e, formik)} error={formik.errors}
                  isFullWidth />
                <Button
                  type="submit"
                  variantColor="gray"
                  color="#fff"
                  backgroundColor="#01509C"
                  _hover={{ background: '#01509C' }}
                  paddingX={10}
                  marginTop="20px"
                  marginBottom="20px"
                  isLoading={formik.isSubmitting}
                >
                  Entrar
                </Button>
              </div>
            </Form>
          }
        </Formik>
      </Content>
    </Container>
  );
});
export default Login;
